"use client"

import { UserRound } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UserRoundIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UserRoundIcon = component(Icon)({ as: UserRound })
